import { ApolloClient, InMemoryCache, ApolloLink, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
//@ts-ignore
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

const uploadLink = createUploadLink({
    uri: import.meta.env.VITE_BACKEND_STRAWBERRY_ENDPOINT,
});

const graphqlWsClient = createClient({
    url: import.meta.env.VITE_BACKEND_WS_STRAWBERRY_ENDPOINT,
    connectionParams: () => {
        const token = localStorage.getItem('jwtToken');
        return {
            headers: {
                token: token ? `Bearer ${token}` : '',
            },
        };
    },
});

const wsLink = new GraphQLWsLink(graphqlWsClient);


export function restartGraphqlWsConnection(): void {
    graphqlWsClient.terminate();
}

const authLink = setContext((_, { headers }) => {
    const token = localStorage.getItem('jwtToken');
    
    if (!token) {
        return { headers };
    }

    return {
        headers: {
            ...headers,
            authorization: `Bearer ${token}`,
        },
    };
});

const splitLink = split(
    ({ query }) => {
        const definition = getMainDefinition(query);
        return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
        );
    },
    wsLink,
    ApolloLink.from([authLink, uploadLink])
);


const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
});

export default client;